import { useQuery } from '@tanstack/react-query';

import { adminApi } from '../api/admin';

function Stat({ label, value, hint }: { label: string; value: number; hint?: string }) {
  return (
    <div className="stat">
      <span className="stat__value">{value.toLocaleString('en-GB')}</span>
      <span className="stat__label">{label}</span>
      {hint && <span className="stat__hint">{hint}</span>}
    </div>
  );
}

export default function MetricsPanel() {
  const { data, isPending, isError } = useQuery({ queryKey: ['metrics'], queryFn: adminApi.metrics });

  if (isPending) {
    return <p className="muted">Loading…</p>;
  }

  if (isError || !data) {
    return <p className="status-error">Could not load metrics.</p>;
  }

  const peak = Math.max(1, ...data.signupsByDay.map((point) => point.count));

  return (
    <>
      <div className="stats">
        <Stat label="Users" value={data.totalUsers} />
        <Stat label="Confirmed" value={data.confirmedUsers} />
        <Stat label="Onboarded" value={data.onboardedUsers} />
        <Stat label="Active trials" value={data.activeTrials} hint="card-less, not revenue" />
        <Stat label="Paying" value={data.payingUsers} hint="real subscription" />
        <Stat label="Active today" value={data.dailyActive} />
        <Stat label="Active this week" value={data.weeklyActive} />
        <Stat label="Disabled" value={data.disabledUsers} />
      </div>

      <section className="card">
        <h2>Sign-ups, last 30 days</h2>
        {/* Bars are plain divs: a chart library for one sparkline is not worth the bundle. */}
        <div className="bars">
          {data.signupsByDay.map((point) => (
            <div
              key={point.date}
              className="bars__bar"
              style={{ height: `${Math.round((point.count / peak) * 100)}%` }}
              title={`${point.date}: ${point.count}`}
            />
          ))}
        </div>
        <p className="muted">
          Peak {peak} on a day · total {data.signupsByDay.reduce((sum, p) => sum + p.count, 0)}
        </p>
      </section>
    </>
  );
}
